import swal from "@/services/SweetAlert";
import HTTP from "@/_helpers/http";
import { BANKINFORMATIONS__API } from "@/_helpers/urls";
import { BANK__INFORMATION__MUTATIONS } from "../mutation-types";
import { BANK__INFORMATION__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  bankInfo: {
    bank_id: "",
    bank_name: "",
    bank_acc_name: "",
    bank_acc_num: "",
    bank_iban_num: "",
    bank_swift_num: "",
    bank_postal_code: "",
    bank_residence_country: "",
    bank_residence_state: "",
    bank_residence_city: "",
    bank_address: "",
  },
};

const getters = {
  isValidToAddBankAccount(state) {
    if (
      state.bankInfo.bank_name &&
      state.bankInfo.bank_acc_name &&
      state.bankInfo.bank_acc_num &&
      state.bankInfo.bank_iban_num &&
      state.bankInfo.bank_swift_num &&
      state.bankInfo.bank_postal_code &&
      state.bankInfo.bank_residence_country &&
      state.bankInfo.bank_residence_state &&
      state.bankInfo.bank_residence_city &&
      state.bankInfo.bank_address
    )
      return true;
    return false;
  },
};

const mutations = {
  [BANK__INFORMATION__MUTATIONS.BANK_INFORMATIONS](state, data) {
    state.bankInfo.bank_id = data.id;
    state.bankInfo.bank_name = data.bank_name;
    state.bankInfo.bank_acc_name = data.bank_acc_name;
    state.bankInfo.bank_acc_num = data.bank_acc_num;
    state.bankInfo.bank_iban_num = data.bank_iban_num;
    state.bankInfo.bank_swift_num = data.bank_swift_num;
    state.bankInfo.bank_postal_code = data.bank_postal_code;
    state.bankInfo.bank_residence_country = data.bank_residence_country;
    state.bankInfo.bank_residence_state = data.bank_residence_state;
    state.bankInfo.bank_residence_city = data.bank_residence_city;
    state.bankInfo.bank_address = data.bank_address;
  },

  [BANK__INFORMATION__MUTATIONS.UPDATE_BANK_LISTS](state, bank) {
    state.bankLists.push(bank);
  },
  [BANK__INFORMATION__MUTATIONS.BANK_NAME](state, data) {
    state.bankInfo.bank_name = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_ACCOUNT_NAME](state, data) {
    state.bankInfo.bank_acc_name = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_ACCOUNT_NUMBER](state, data) {
    state.bankInfo.bank_acc_num = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_COUNTRY](state, data) {
    state.bankInfo.bank_residence_country = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_STATE](state, data) {
    state.bankInfo.bank_residence_state = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_CITY](state, data) {
    state.bankInfo.bank_residence_city = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_IBAN_NUMBER](state, data) {
    state.bankInfo.bank_iban_num = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_POSTAL_CODE](state, data) {
    state.bankInfo.bank_postal_code = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_SWIFT_NUMBER](state, data) {
    state.bankInfo.bank_swift_num = data;
  },

  [BANK__INFORMATION__MUTATIONS.BANK_ADDRESS](state, data) {
    state.bankInfo.bank_address = data;
  },

  [BANK__INFORMATION__MUTATIONS.RESET](state) {
    state.bankInfo = {
      bank_name: "",
      bank_acc_name: "",
      bank_acc_num: "",
      bank_iban_num: "",
      bank_swift_num: "",
      bank_postal_code: "",
      bank_residence_country: "",
      bank_residence_state: "",
      bank_residence_city: "",
      bank_address: "",
    };
  },
};

const actions = {
  async [BANK__INFORMATION__ACTIONS.GETBANKINFORMATIONS]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        BANKINFORMATIONS__API.GETBANKINFORMATIONS
      );
      commit(BANK__INFORMATION__MUTATIONS.BANK_INFORMATIONS, response.data);
    } catch (error) {
      console.log(error.response || error);
    }
  },

  async [BANK__INFORMATION__ACTIONS.UPDATEBANKINFORMATIONS]({ commit, state }) {
    try {

      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(
        BANKINFORMATIONS__API.UPDATEBANKACCOUNT,
        {
          bank_id: state.bankInfo.bank_id,
          bank_name: state.bankInfo.bank_name,
          bank_acc_name: state.bankInfo.bank_acc_name,
          bank_acc_num: state.bankInfo.bank_acc_num,
          bank_iban_num: state.bankInfo.bank_iban_num,
          bank_swift_num: state.bankInfo.bank_swift_num,
          bank_postal_code: state.bankInfo.bank_postal_code,
          bank_residence_country: state.bankInfo.bank_residence_country,
          bank_residence_state: state.bankInfo.bank_residence_state,
          bank_residence_city: state.bankInfo.bank_residence_city,
          bank_address: state.bankInfo.bank_address,
        }
      );

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  },

  async [BANK__INFORMATION__ACTIONS.ADDNEWBANKACCOUNT]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(
        BANKINFORMATIONS__API.ADDNEWBANKACCOUNT,
        {
          bankInfo: state.bankInfo,
        }
      );

      commit(BANK__INFORMATION__MUTATIONS.UPDATE_BANK_LISTS, response.data);
      commit("modal/CLOSE_MODAL", null, { root: true });
      commit(BANK__INFORMATION__MUTATIONS.REBANK_INFO);

      swal.fire({
        type: "success",
        title: "Hooray!!",
        text: "Bank account added successfully",
      });
    } catch (error) {
      console.log(error.response || error);
    }
  },

  async [BANK__INFORMATION__ACTIONS.DELETEBANKACCOUNT]({ commit }, bank_id) {
    try {
      const result = await swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "PROCEED",
        cancelButtonText: "BACK",
      });

      if (result.value) {
        const response = await HTTP().post(
          BANKINFORMATIONS__API.DELETEBANKACCOUNT,
          {
            id: bank_id,
          }
        );

        console.log(response.data);

        if (response.data === "success") {
          commit(
            BANK__INFORMATION__MUTATIONS.UPDATE_BANK_LISTS_AFTER_DELETE,
            bank_id
          );

          swal.fire({
            type: "success",
            title: "Hooray!!",
            text: "Bank account deleted successfully",
          });
        }
      }
    } catch (error) {
      console.log(error.response || error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
